// quizReducer.js
import {
  VALIDATE_QUIZ_REQUEST,
  VALIDATE_QUIZ_SUCCESS,
  VALIDATE_QUIZ_FAILURE,
  RESET_QUIZ_RESULT
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  result: null,
  error: null,
};


const quizReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_QUIZ_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case VALIDATE_QUIZ_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case VALIDATE_QUIZ_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case RESET_QUIZ_RESULT:
      return {
        ...state,
        result: null,
      };
    default:
      return state;
  }
};

export default quizReducer;
